import React, { useMemo } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import get from 'lodash/get';

const GenericChart = props => {
  const {
    defaultConfig,
    xAxisCategories = [],
    yAxisCategories = [],
    series = [],
    tooltipValueKeysConfig = {
      isheaderVisible: true,
      headerLabelKey: '',
      bodyLabelKey: '',
      bodyValueKey: '',
      bodyLabelValue: ""
    }
  } = props;

  const chartOption = useMemo(() => {
    const extraConfig = {
      tooltip: {
        formatter: function (e) {
          const pointsList = this.points || [this];
          const headerLabel = get(
            this,
            tooltipValueKeysConfig.headerLabelKey,
            this.x !== undefined ? this.x : this.key
          );
          let body = '';
          pointsList.forEach(item => {
            const label = get(
              item,
              tooltipValueKeysConfig.bodyLabelKey,
              item.point.name || item.series.name || 'Series'
            );
            const value = get(item, tooltipValueKeysConfig.bodyValueKey, item.y);
            const color = get(item, 'color', get(item, 'point.color', ''));
            body += `
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <div style="
              width: 10px; height: 10px;
              background: ${color};
              border-radius: 50%; 
            "></div>
            <div>${tooltipValueKeysConfig?.bodyLabelValue || label} &nbsp;&nbsp;&nbsp;&nbsp;</div>
          </div>
          <span style="font-weight: 600;">${value}</span>
        </div>`;
          });

          return `
       <div style="
         background: #1e222c;
         color: #fff;
         padding: 12px 18px;
         border-radius: 14px;
         font-size: 14px;
         box-shadow: 0 4px 14px rgba(0,0,0,0.25);
         display: flex;
         flex-direction: column;
         gap: 6px;
         pointer-events: none;
       ">
         ${get(tooltipValueKeysConfig, 'isheaderVisible', false)
              ? `<div style="font-size: 14px; font-weight: 600; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 4px; margin-bottom: 4px;">
          ${headerLabel}
         </div>`
              : ''
            }
          ${body}
       </div>
 
       <div style="
         width: 0; height: 0; margin: 0 auto;
         border-left: 10px solid transparent;
         border-right: 10px solid transparent;
         border-top: 12px solid #1e222c;
       "></div>
     `;
        },
        positioner: function (labelWidth, labelHeight, point) {
          return {
            x: point.plotX + this.chart.plotLeft - labelWidth / 2,
            y: point.plotY + this.chart.plotTop - labelHeight
          };
        }
      },
      xAxis: {
        categories: xAxisCategories
      },
      yAxis: {
        categories: yAxisCategories
      },
      series: series
    };
    return Highcharts.merge(defaultConfig, extraConfig);
  });
  return <HighchartsReact highcharts={Highcharts} options={chartOption} />;
};
export default GenericChart;
